import { Locale } from "@lookiero/sty-psp-locale";
const SIZES = {
    [Locale.en_GB]: [
        { size: "XS", jeans: "27-28", bust: "34-35", waist: "27-29.5", hip: "36-37.5" },
        { size: "S", jeans: "29-30", bust: "35.5-36.5", waist: "30-32.5", hip: "38-40" },
        { size: "M", jeans: "31-32", bust: "37-38", waist: "33-35.5", hip: "40.5-42.5" },
        { size: "L", jeans: "33-34", bust: "38.5-39.5", waist: "36-39", hip: "43-46" },
        { size: "XL", jeans: "36", bust: "40-41.5", waist: "39.5-40.5", hip: "46.5-47" },
        { size: "XXL", jeans: "38-40", bust: "42-43", waist: "41-43.5", hip: "47.5-49.5" },
        { size: "3XL", jeans: "42", bust: "43.5-44.5", waist: "44-45", hip: "50-51" },
    ],
    default: [
        { size: "XS", jeans: "27-28", bust: "86-89", waist: "69-75", hip: "91-96" },
        { size: "S", jeans: "29-30", bust: "90-93", waist: "76-83", hip: "97-102" },
        { size: "M", jeans: "31-32", bust: "94-97", waist: "84-91", hip: "103-108" },
        { size: "L", jeans: "33-34", bust: "98-101", waist: "92-99", hip: "109-117" },
        { size: "XL", jeans: "36", bust: "102-106", waist: "100-103", hip: "118-120" },
        { size: "XXL", jeans: "38-40", bust: "107-109", waist: "104-111", hip: "121-126" },
        { size: "3XL", jeans: "42", bust: "110-113", waist: "112-115", hip: "127-129" },
    ],
};
const LEG_LENGTH_SIZES = {
    [Locale.en_GB]: [
        { length: "30", legLength: "30", height: `5" 5' - 5" 7'` },
        { length: "32", legLength: "32", height: `5" 7' - 5" 11'` },
        { length: "34", legLength: "34", height: `5" 11' - 6" 2'` },
        { length: "36", legLength: "36", height: `6" 2' - 6" 5'` },
    ],
    default: [
        { length: "30", legLength: "76", height: "165-172" },
        { length: "32", legLength: "81", height: "173-180" },
        { length: "34", legLength: "86", height: "181-188" },
        { length: "36", legLength: "91", height: "189-195" },
    ],
};
export { SIZES, LEG_LENGTH_SIZES };
